import { render, staticRenderFns } from "./AgentFunction.vue?vue&type=template&id=ecc95830&scoped=true"
import script from "./AgentFunction.vue?vue&type=script&lang=js"
export * from "./AgentFunction.vue?vue&type=script&lang=js"
import style0 from "./AgentFunction.vue?vue&type=style&index=0&id=ecc95830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc95830",
  null
  
)

export default component.exports